<template>
  <section class="landing-page">
    <Header />
    <slot />
    <Pricing />
    <ProductHunt />
    <Footer />
  </section>
</template>

<script>
import Header from '@/components/landing/Header';
import Pricing from '@/components/landing/Pricing';
import ProductHunt from '@/components/landing/ProductHunt';
import Footer from '@/components/landing/Footer';

export default {
  components: {
    Header,
    Pricing,
    ProductHunt,
    Footer,
  },
};
</script>

<style scoped>
* {
  color: #3d3d3d;
}

.landing-page {
  width: 100%;
  box-sizing: border-box;
}
</style>
